import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 15 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.875 14.25C5.10723 14.25 4.22335 14.25 3.67417 13.7008C3.125 13.1517 3.125 12.2678 3.125 10.5L3.125 7.375C3.125 5.60723 3.125 4.72335 3.67417 4.17417C4.22335 3.625 5.10723 3.625 6.875 3.625C8.64277 3.625 9.52665 3.625 10.0758 4.17417C10.625 4.72335 10.625 5.60723 10.625 7.375L10.625 10.5C10.625 12.2678 10.625 13.1517 10.0758 13.7008C9.52665 14.25 8.64277 14.25 6.875 14.25Z",
      stroke: "currentColor",
      "stroke-width": "1.2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5.04736 3.62484C5.10731 3.01541 5.24278 2.6052 5.54896 2.29902C6.09814 1.74984 6.98202 1.74984 8.74979 1.74984C10.5176 1.74984 11.4014 1.74984 11.9506 2.29902C12.4998 2.84819 12.4998 3.73207 12.4998 5.49984L12.4998 8.62484C12.4998 10.3926 12.4998 11.2765 11.9506 11.8257C11.6444 12.1319 11.2342 12.2673 10.6248 12.3273",
      stroke: "currentColor",
      "stroke-width": "1.2"
    }, null, -1)
  ])))
}
export default { render: render }